export class UserQueryRequest {
   emailAddress?: string;
   propertyId: number = 0;
   currentUser: boolean = false;
}
